import React, { memo, useMemo } from 'react';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Col.scss';
const rootClassName = 'component-col';

interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  cols?: Array<1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12>;
  centralized?: boolean;
  end?: boolean;
  gap?: number | string;
  noPadding?: boolean;
  children?: React.ReactNode;
  noPaddingTop?: boolean;
  buttonActionsCol?: boolean;
}

function Col(props: ColProps) {
  const p = useMemo(() => {
    const cols = props.cols ? props.cols : [12, 12, 12, 12, 12];
    const size = ['xs', 'sm', 'md', 'lg', 'xl'];
    const getSizes = cols.map((n, index) => {
      return `${rootClassName}-${size[index]}-${n}`;
    });
    const rp = {
      ...props,
      style: { ...(props.style || {}), gap: props.gap },
      className: getMergedClassNames([
        props.className,
        rootClassName,
        ...getSizes,
        props.centralized ? 'centralized' : '',
        props.end ? 'end' : '',
        props.noPadding ? 'no-padding' : '',
        props.noPaddingTop ? 'no-padding-top' : '',
        props.buttonActionsCol ? 'button-actions-col' : '',
      ]),
    };
    delete rp.noPadding;
    delete rp.centralized;
    delete rp.end;
    delete rp.cols;
    delete rp.children;
    delete rp.buttonActionsCol;
    delete rp.noPaddingTop;
    return rp;
  }, [props]);

  return <div {...p}>{props.children}</div>;
}

Col.defaultProps = {
  cols: [12, 12, 12, 12, 12],
  centralized: false,
  end: false,
  noPadding: false,
};

export default memo(Col);
